interface HeaderLogoProps {
  children: React.ReactNode;
  url?: string;
}

export default function HeaderLogo({
  children,
  url = import.meta.env.VITE_BASE_URL || window.location.origin,
}: Readonly<HeaderLogoProps>) {
  return <a href={url}>{children}</a>;
}
